import React from 'react';

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl font-bold text-neutral-900 mb-8 text-center">
          Terms of Use
        </h1>

        <div className="bg-white rounded-lg shadow-lg p-8 space-y-6">
          <section>
            <h2 className="text-2xl font-semibold text-neutral-800 mb-4">
              Welcome to Rishabh Enterprises Private Limited
            </h2>
            <p className="text-neutral-700 leading-relaxed">
              These Terms of Use outline the rules and regulations for the use of the RE app.
              By accessing this we assume you accept these Terms of Use. Do not continue to use
              our app/website if you don't agree to take all of the Terms of Use stated on this page.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-800 mb-4">
              Agent Responsibilities
            </h2>

            <div className="space-y-4">
              <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded">
                <h3 className="font-semibold text-neutral-800 mb-2">Vehicle Tag Activation</h3>
                <p className="text-neutral-700">
                  If any tag is active by the agent with the wrong vehicle number, then the agent
                  will be responsible for it and the agent will have to pay the penalty as prescribed
                  by the bank.
                </p>
              </div>

              <div className="bg-amber-50 border-l-4 border-amber-500 p-4 rounded">
                <h3 className="font-semibold text-neutral-800 mb-2">Unregistered Tag Activation</h3>
                <p className="text-neutral-700">
                  If the tag active by the agent is unregistered then the payment for that amount
                  will be recovered from the agent.
                </p>
              </div>

              <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
                <h3 className="font-semibold text-neutral-800 mb-2">Document Upload Requirements</h3>
                <p className="text-neutral-700">
                  This should be done by the agent by ensuring that the customer's documents are
                  uploaded clearly. The agent must pay the penalty fixed by the bank.
                </p>
              </div>

              <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded">
                <h3 className="font-semibold text-neutral-800 mb-2">Document Misuse Prohibition</h3>
                <p className="text-neutral-700">
                  The agent is not allowed to use documents of any other customer while activating
                  Fastag. If the agent does so then he will be held responsible for it.
                </p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-800 mb-4">
              Intellectual Property
            </h2>
            <p className="text-neutral-700 leading-relaxed">
              RE reserves the right to monitor all comments and to remove any comments that can be
              considered inappropriate, offensive, or cause a breach of these Terms of Use. No use
              of the RE logo or other artwork will be allowed for linking absent a Trademark license
              agreement.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-neutral-800 mb-4">
              Changes to Terms
            </h2>
            <p className="text-neutral-700 leading-relaxed">
              We reserve the right to change the Terms of Use from time to time without any notice
              and it is the responsibility of agents and customers to go through the policies, terms,
              and conditions mentioned on this website or app.
            </p>
          </section>

          <section className="bg-neutral-50 p-6 rounded-lg">
            <h2 className="text-xl font-semibold text-neutral-800 mb-3">
              Important Notice
            </h2>
            <p className="text-neutral-700 leading-relaxed">
              By using Rishabh Enterprises' services, you acknowledge that you have read, understood,
              and agree to be bound by these Terms of Use. If you have any questions or concerns,
              please contact our support team.
            </p>
          </section>
        </div>

        <div className="mt-8 text-center">
          <p className="text-neutral-600 text-sm">
            Last Updated: August 2024
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUse;
